<template lang="html">
  <svg
    class="app-spinner"
    :class="{ 'is-centered': isCentered }"
    viewBox="0 0 24 24"
  >
    <g transform="translate(1, 1)" fill-rule="nonzero" fill="none">
      <circle cx="11" cy="11" r="11"></circle>
      <path
        d="M10.998 22a.846.846 0 0 1 0-1.692 9.308 9.308 0 0 0 0-18.616 9.286 9.286 0 0 0-7.205 3.416.846.846 0 1 1-1.31-1.072A10.978 10.978 0 0 1 10.998 0c6.075 0 11 4.925 11 11s-4.925 11-11 11z"
        :fill="color"
      ></path>
    </g>
  </svg>
</template>

<script>
import { colors } from '@/constants';

export default {
  name: 'AppSpinner',

  props: {
    size: {
      type: String,
      default: '24',
    },

    color: {
      type: String,
      default: colors.spinner,
    },

    isCentered: {
      type: Boolean,
      default: true,
    },
  },

  mounted() {
    this.positionSpinner();
  },

  methods: {
    positionSpinner() {
      const size = `${this.size}px`;

      this.$el.style.width = size;
      this.$el.style.height = size;

      if (!this.isCentered) return;

      const margin = `-${this.size / 2}px`;
      this.$el.style.marginLeft = margin;
      this.$el.style.marginTop = margin;
    },
  },
};
</script>

<style scoped lang="scss">
.app-spinner {
  animation: spinner-animation-show map-get($transition-speeds, 'normal') normal
      ease,
    spinner-animation-rotation map-get($transition-speeds, 'slow') linear
      infinite;

  &.is-centered {
    position: absolute;
    top: 50%;
    left: 50%;
  }

  @keyframes spinner-animation-show {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes spinner-animation-rotation {
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
